import { render, staticRenderFns } from "./InternalAppointmentForm.vue?vue&type=template&id=1febfd18"
import script from "./InternalAppointmentForm.vue?vue&type=script&lang=ts"
export * from "./InternalAppointmentForm.vue?vue&type=script&lang=ts"
import style0 from "./InternalAppointmentForm.vue?vue&type=style&index=0&id=1febfd18&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports